import { TableBody as MuiTableBody, TableBodyProps as MuiTableBodyProps } from '@mui/material'
import styled from 'styled-components'

export type TableBodyPropsType = MuiTableBodyProps

const TableBody = styled(MuiTableBody)<TableBodyPropsType>``
export default TableBody
